const comMain = () => {
  const jsComSecMain = (document.getElementById("jsComSecMain") != null);
  if (jsComSecMain) {


    // let sW = window.innerWidth;
    // let sH = window.innerHeight;

    let jsComSecMain = document.getElementById("jsComSecMain")
    let coverBox = jsComSecMain.querySelector(".js-cover-box")
    let ttlBox = jsComSecMain.querySelector(".js-ttl-box")
    let tabWrap = jsComSecMain.querySelector(".js-tab-wrap")


    setTimeout(() => {
      coverBox.classList.add('act')
    }, 500);

    setTimeout(() => {
      ttlBox.classList.add('act')
      if(tabWrap){
        tabWrap.classList.add('act')
      }
    }, 1000);



  }
}
export default comMain;